import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .title': {
    marginBottom: theme.spacing(2),
  },
  '& .IVAbout': {
    'p:not(:last-child):not(.MuiTypography-root)': {
      marginBottom: theme.spacing(2),
    },
  },
}));

export default StyledBox;
